var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7009 24.75H18.2009M22.7009 33.75H18.2009M36.2009 15.75H18.2009M45.2009 15.3V38.7C45.2009 42.4804 45.2009 44.3705 44.4652 45.8144C43.8181 47.0845 42.7855 48.1171 41.5154 48.7643C40.0715 49.5 38.1813 49.5 34.4009 49.5H20.0009C16.2206 49.5 14.3304 49.5 12.8865 48.7643C11.6164 48.1171 10.5838 47.0845 9.93663 45.8144C9.20093 44.3705 9.20093 42.4804 9.20093 38.7V15.3C9.20093 11.5196 9.20093 9.62947 9.93663 8.18556C10.5838 6.91547 11.6164 5.88285 12.8865 5.23571C14.3304 4.5 16.2206 4.5 20.0009 4.5H34.4009C38.1813 4.5 40.0715 4.5 41.5154 5.23571C42.7855 5.88285 43.8181 6.91547 44.4652 8.18556C45.2009 9.62947 45.2009 11.5196 45.2009 15.3Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralNote);
export default __webpack_public_path__ + "static/media/GeneralNote.f4c29b7d7b809723795e6e68bb71f207.svg";
export { ForwardRef as ReactComponent };